<template>
  <v-menu
    bottom
    left
    min-width="350"
    offset-y
    origin="top right"
    :close-on-content-click="false"
    transition="scale-transition"
  >
    <template v-slot:activator="{ attrs, on }">
      <v-btn
        id="user-account-btn"
        text
        v-bind="attrs"
        v-on="on"
      >
        <span class="user-name mr-3">
          {{ currentUser.firstName }}
          <br>
          {{ currentUser.lastName }}
        </span>
        <account-icon :size="36" />
      </v-btn>
    </template>

    <v-list>
      <template v-if="orgIsSelected">
        <v-list-item
          class="account-menu-item__role px-5"
          style="height: 44px;"
        >
          {{ userRoleOnOrg }}
        </v-list-item>
        <v-divider style="background-color: #E1EBEE" />
      </template>
      <v-list-item
        class="account-menu-item"
        @click="goToAccountSettings"
      >
        <v-list-item-content class="account-menu-item__content">
          Account Settings
        </v-list-item-content>
        <v-list-item-icon class="account-menu-item__icon">
          <v-icon
            size="15"
            color="#535353"
          >
            $faUser
          </v-icon>
        </v-list-item-icon>
      </v-list-item>
      <v-list-item
        class="account-menu-item"
        @click="logout"
      >
        <v-list-item-content class="account-menu-item__content">
          Log Out
        </v-list-item-content>
        <v-list-item-icon class="account-menu-item__icon">
          <v-icon
            size="15"
            color="#535353"
          >
            $faArrowRight
          </v-icon>
        </v-list-item-icon>
      </v-list-item>
      <v-divider
        v-if="isInternal"
        class="mb-2 mt-2"
      />
      <v-list-item v-if="isInternal">
        <v-switch
          v-model="$vuetify.theme.dark"
          class="ma-0 pa-0"
          color="primary"
          label="Toggle Dark Mode"
        />
      </v-list-item>
    </v-list>
  </v-menu>
</template>

<script>
  import { mapGetters } from 'vuex'
  import accountMenuMixin from '@/helpers/account-menu-mixin.js'

  export default {
    name: 'AccountMenu',
    mixins: [accountMenuMixin],
    computed: {
      ...mapGetters({
        currentSelectedOrg: 'Permissions/currentSelectedOrg',
        canAdminSelectedOrg: 'Permissions/canAdminSelectedOrg',
      }),
    },
  }
</script>

<style lang="scss">
#user-account-btn {
  justify-content:flex-end;
  min-width:71px;
  padding-right:0 !important;
}
.user-name {
    font-family: 'Lato', sans-serif;
    font-style: normal;
    font-weight: 600;
    font-size: 10px;
    line-height: 12px;
    text-align: right;
    letter-spacing: 1.5px;
    text-transform: uppercase;
    color: #535353;
}
.occupancy-risk-container {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}
.occupancy-risk-body {
  font-family: 'Lato';
  font-size: 15px;
  font-weight: 400;
  line-height: 18px;
  letter-spacing: 0.5px;
  text-align: left;
}
.occupancy-risk-detail {
  font-family: 'Degular';
  font-size: 14px;
  font-weight: 400;
  line-height: 19px;
  letter-spacing: 0.4277777671813965px;
  text-align: left;
}
.account-menu-item {
  padding: 12px 20px;
  height: 52px;
}
.account-menu-item__content {
  font-family: 'Degular', sans-serif;
  padding: 0;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 20px;
  letter-spacing: 0.191002px;
  color: #34455F !important;
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: space-between;
}
.account-menu-item__icon {
  margin: auto 0 auto auto;
  min-width: 15px;
}
.account-menu-item__role.theme--light.v-list-item:not(.v-list-item--active):not(.v-list-item--disabled) {
  font-family: 'Degular', sans-serif;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 18px;
  letter-spacing: 1px;
  text-transform: uppercase;
  color: #535353 !important;
}
</style>
